<template>
  <common-button
    :disabled="isSubmitting"
    @click="revokeAllTokensWhenConfirmed"
    icon="trash"
    type="danger"
  >{{$t('text')}}</common-button>
</template>

<script>
import { mapActions } from 'vuex';
import UIkit from 'uikit';
import Authentication from '@/mixins/Authentication';
import CommonButton from '@/components/CommonButton';
import revokeAllTokensMutation from '@/api/mutations/revoke-all-tokens.graphql';
import Toast from '@/helpers/Toast';
import Tooltip from '@/components/Tooltip';

export default {
  name: 'revoke-all-tokens-button',
  mixins: [
    Authentication,
  ],
  components: {
    CommonButton,
    Tooltip,
  },
  props: {
    subject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  computed: {
    subjectId() {
      return this.subject.id;
    },
    subjectType() {
      // eslint-disable-next-line no-underscore-dangle
      return this.subject.__typename;
    },
    forCurrentUser() {
      return this.isAuthenticated &&
             this.subjectType === 'User' &&
             this.subjectId === this.currentUser.id;
    },
  },
  methods: {
    async revokeAllTokens() {
      this.isSubmitting = true;
      const options = {
        mutation: revokeAllTokensMutation,
        variables: { id: this.subjectId, type: this.subjectType },
      };
      // this.$t wont work inside the mutate fun...
      const msg = this.$t('toast', { name: this.subject.name });
      await this.$apollo.mutate(options);
      this.isSubmitting = false;
      Toast.success(msg);
      if (this.forCurrentUser) {
        await this.enforceLogout();
        this.$router.push({
          name: 'login',
          query: { returnTo: this.$route.fullPath },
        });
      }
      this.$emit('done');
    },
    revokeAllTokensWhenConfirmed() {
      UIkit.modal
        .confirm(this.$t('confirm', { name: this.subject.name }))
        .then(() => { this.revokeAllTokens(); })
        .catch(() => { });
    },
    ...mapActions(['enforceLogout']),
  },
  i18n: {
    messages: {
      de: {
        text: 'Alle Widerrufen',
        confirm: 'Wirklich alle Zugangsschlüssel widerrufen?',
        toast: 'Alle Zugangsschlüssel für {name} wurden widerrufen!',
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// RevokeAllTokensButton.vue?08d38c3e